import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * GIS focus mode: hide app header + sidenav so the map fills the window.
 * Session-only; auto-cleared when leaving GIS routes.
 */
@Injectable({ providedIn: 'root' })
export class GisFocusService {
  private readonly focusSubject = new BehaviorSubject<boolean>(false);
  readonly isFocusMode$ = this.focusSubject.asObservable();

  /** True while GIS drawing owns Escape (multi-line / curve). */
  private drawingEscCaptured = false;

  get isFocusMode(): boolean {
    return this.focusSubject.value;
  }

  enter(): void {
    if (!this.focusSubject.value) this.focusSubject.next(true);
  }

  exit(): void {
    if (this.focusSubject.value) this.focusSubject.next(false);
  }

  toggle(): void {
    this.focusSubject.next(!this.focusSubject.value);
  }

  setDrawingEscCaptured(captured: boolean): void {
    this.drawingEscCaptured = captured;
  }

  isDrawingEscCaptured(): boolean {
    return this.drawingEscCaptured;
  }

  static isGisMapUrl(url: string): boolean {
    const path = url.split('?')[0];
    if (path.includes('geospatial-dashboard')) {
      return false;
    }
    return (
      path.includes('/geospatial') ||
      path.includes('gis-project/') ||
      path.includes('gis-mvp') ||
      path.includes('nhai-gis') ||
      path.includes('map-editor-ol-avi')
    );
  }
}
